<template>
    <div class="content">
        <div v-for="(item,index) in listData" :key="index" class="project-all">
            <div class="project-box" :style="{background: (item.is_default == 0 ?'#F0F0F0':'#FFFFFF') }">
                <div class="project-top">
                    <div class="title">{{item.new_name}}</div>
                    <div class="const" v-if='item.new_status == 0'>无合同</div>
                    <div class="const" v-if='item.new_status == 1'>未签约</div>
                    <div class="const" v-if='item.new_status == 2'>未进场</div>
                    <div class="const" v-if='item.new_status == 3'>未完工</div>
                    <div class="const" v-if='item.new_status == 4'>已完工</div>
                </div>
                <div class="lable">
                    <div class="square">{{ item.new_area ? item.new_area : '' }} ㎡</div>
                    <div class="room">
                        {{item.new_roomnumber ? item.new_roomnumber + "室" : ""}}{{item.new_hall ? item.new_hall + "厅" : ""}}{{item.new_toilet ? item.new_toilet + "卫" : ""}}
                    </div>
                    <div class="type">{{ item.new_housetype_name ? item.new_housetype_name : "不详" }}</div>
                </div>
                <div class="line-box">
                    <div class="garden-box-wit">
                        <div :class="item.new_status >= 1 ?'garden-box':'garden-box-item'"></div>
                    </div>
                    <div class="garden-box-wit">
                        <div :class="item.new_status >= 2 ?'garden-box':'garden-box-item'"></div>
                    </div>
                    <div class="garden-box-wit">
                        <div :class="item.new_status >= 3 ?'garden-box':'garden-box-item'"></div>
                    </div>
                    <div class="garden-box-wit">
                        <div :class="item.new_status >= 4 ?'garden-box':'garden-box-item'"></div>
                    </div>
                    <div class="short-line"
                        :style="{width: ( (item.new_status - 1) * 30 + 5 + (item.new_status==4? 5 :'') + '%')}"></div>
                    <div class="long-line"
                        :style="{width:  ((item.new_status==4 ? 0 : 25 ) + (4 - item.new_status)*90 + 'px')}">
                    </div>
                </div>
                <div class="process">
                    <div class="process-title">设计<br />方案</div>
                    <div class="process-title">签订<br />合同</div>
                    <div class="process-title">施工<br />验收</div>
                    <div class="process-title">无忧<br />售后</div>
                </div>
            </div>
            <div class="project-bottom" @click="getToDetails">
                <div class="bottom-title">项目进度总览</div>
                <div class="bottom-img"><img :src="require('@/assets/images/project/navgetTo.png')" /></div>
            </div>
            <div class="choice-box" @click="article(item,item.new_contractid)">
                <img :src="require('@/assets/images/project/current.png') " v-if="item.is_default == 1" />
                <img :src="require('@/assets/images/project/choice.png') " v-else />
            </div>
        </div>
        <div class="home_icon" @click="getHome" :style="{bottom: showInfo == 2 ? '108px':'88px'}">
            <img  src="@/assets/images/member/v2/plan/home_icon.png"/>
        </div>



        <div v-if="false">
            <pull-to :top-load-method="downRefreshTwo" :bottom-load-method="upRefreshTwo" :is-bottom-bounce="true"
                bottom-block-height:0 top-block-height:0 v-if="listData.length&&bLoadList">
                <!-- Business card -->
                <div v-for="(item1, index1) in listData" :key="index1"
                    @click.stop="article(index1,item1.new_contractid)" class="public div-margin">
                    <!-- card -->
                    <div class="card">
                        <!-- img  未完工 -->
                        <div v-if="item1.new_status == 0" class="img"></div>
                        <div v-if="item1.new_status == 1" class="img"></div>
                        <!-- uncourse 未进场 -->
                        <div v-if="item1.new_status == 2" class="img uncourse"></div>
                        <!-- working 施工中 -->
                        <div v-if="item1.new_status == 3" class="img working"></div>
                        <!-- unfinished 已完工 -->
                        <div v-if="item1.new_status == 4" class="img unfinished"></div>
                        <div :class="item1.new_status ? '' : 'topping'" class="top">
                            <!-- text -->
                            <div class="text">
                                <div class="text-top">{{ item1.new_name }}</div>
                                <div class="text-bottom">
                                    <div class="left">{{ item1.name }}</div>
                                    <!-- <div class="right">NO.{{ item1.new_srv_projectmgnid }}</div> -->
                                </div>
                            </div>
                            <!--  layer -->
                            <!-- <div class="layer">空调壁挂炉</div> -->
                            <!-- lable -->
                            <div class="lable">
                                <div>{{ Number(item1.new_area).toFixed(0) }} ㎡</div>
                                <div>
                                    {{item1.new_roomnumber ? item1.new_roomnumber + "室" : ""}}{{item1.new_hall ? item1.new_hall + "厅" : ""}}{{item1.new_toilet ? item1.new_toilet + "卫" : ""}}{{item1.new_kitchen ? item1.new_kitchen + "厨" : ""}}
                                </div>
                                <div>{{ item1.new_housetype_name ? item1.new_housetype_name : "不详" }}</div>
                            </div>
                        </div>
                    </div>
                    <!--  progress -->
                    <div class="progress">
                        <hr class="line" />
                        <template v-for="(item, index) in item1.process.btn_cur">
                            <div class="progress-item" :key="index">
                                <!-- imgacd 完成进度    imghide 未完成进度与未选择项目   -->
                                <div :class="item.type_id ? 'imgacd' : 'imghide'" class="img"></div>
                                <div :class="item.type_id ? 'item-font' : 'font-text'">
                                    <template v-if="index == 4">
                                        {{ item.type_name.slice(0, 3) }}
                                    </template>
                                    <template v-else>
                                        {{ item.type_name.slice(0, 2) }}
                                    </template>
                                </div>
                                <div :class="item.type_id ? 'item-font' : 'font-text'">
                                    <template v-if="index == 4">
                                        {{ item.type_name.slice(3, 5) }}
                                    </template>
                                    <template v-else>
                                        {{ item.type_name.slice(2, 5) }}
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!-- choose -->
                    <!-- 项目是否选择 -->
                    <hr class="line1" />
                    <div @click.stop="patientia(item1.new_contractid, defaultindex === item1.is_default || item1.is_default == 1)"
                        class="choose">
                        <!-- default--已选择项目 -->
                        <img v-if="defaultindex === item1.is_default || item1.is_default == 1" class="left"
                            src="~@/assets/images/user/house/default.png" alt="" />
                        <!-- default--未选择项目 -->
                        <img v-else class="left" src="~@/assets/images/user/house/finish_icon_n.png" alt="" />
                        <div
                            :class="defaultindex === item1.is_default || item1.is_default == 1 ? 'font-text1' : 'font-text'">
                            {{defaultindex === item1.is_default || item1.is_default == 0 ? "当前选择项目" : "选择该项目"}}
                        </div>
                    </div>
                </div>
            </pull-to>
            <div v-else-if="!listData.length&&!bLoadList" class="infoReadis">
                <div>
                    正在加载数据...
                </div>
            </div>
            <!-- <div v-else class="infoReadis">
            <div>
                该用户当前未签订合同
            </div>
        </div> -->
        </div>
        <share :isFixed="true" v-if="showInfo == 2"></share>
    </div>
</template>
<script>
    import share from '../components/share.vue'
    import {
        getSetPact
    } from "@/js/house/index";
    import {
        getProectList
    } from '@/js/house/index.js';
    import PullTo from "vue-pull-to";
    import common from "@/common/common";
    import {getCreatelog} from "@/js/member/mynews/index.js";
    export default {
        components: {
            PullTo,
            share
        },
        name: "",
        data() {
            return {
                defaultindex: null, // 设置默认选中的
                bLoadList: false, //是否加载完数据
                paramse: {
                    // 列表参数
                    page: 0,
                    limit: 10,
                },
                total: 0, // 列表总页数
                listData: [], // 列表数据

                user_id: 0, // 会员信息主键id
                arrProject: [{
                        new_name: '东湖区利明道1栋2室东湖利明道东湖区利明道1栋2室东湖利明道ssss',
                        new_status: 2, //进度状态
                        new_area: '205',
                        new_roomnumber: '3',
                        new_hall: '1',
                        new_toilet: '2',
                        new_housetype_name: '平层',
                        isProject: 1, //进度
                        is_default: 1, //进度
                    },
                    {
                        new_name: '东湖区利明道1栋2室东湖利明道东湖区利明道1栋2室东湖利明道ssss',
                        new_status: 3,
                        new_area: '205',
                        new_roomnumber: '3',
                        new_hall: '1',
                        new_toilet: '2',
                        new_housetype_name: '平层',
                        isProject: 2, //进度
                        is_default: 0, //进度
                    },
                    {
                        new_name: '东湖区利明道1栋2室东湖利明道东湖区利明道1栋2室东湖利明道ssss',
                        new_status: 1,
                        new_area: '205',
                        new_roomnumber: '3',
                        new_hall: '1',
                        new_toilet: '2',
                        new_housetype_name: '平层',
                        isProject: 4, //进度
                        is_default: 0, //进度
                    }
                ],
                showInfo:false,
            };
        },
        created() {
            let that = this;
            $init(() => {
                let sampleroom = this.$route.query.sampleroom || 0;
                if (sampleroom == 2 || sampleroom == 3) {
                    this.showInfo = true;
                }
                that.getDataList();
                // that.getProject();
            });
            that.user_id = that.$userHouse.state.userInfor.id;
        },
        methods: {
            getHome() {
                let objSam =this.$route.query;
                this.$router.push(`/member/v2/index/index?sharePersonId=${objSam.sharePersonId || ''}&sampleroom=${objSam.sampleroom}&accountid=${objSam.accountid}&contractid=${objSam.contractid}&systemuserid=${objSam.systemuserid}`)
            },
            getProject() {
                getProectList().then((res) => {
                    console.log(res, 'resssss')
                })
            },
            //切换项目
            changePro(index, item) {
                this.arrProject.forEach(it => {
                    it.is_default = 0
                })
                item.is_default = 1
            },
            //跳转用户交付在线
            getToDetails() {
                let objData = this.$route.query;
                let data = {
                    sampleroom: objData.sampleroom || '',
                    accountid: objData.accountid || '',
                    contractid: objData.contractid || '',
                    systemuserid: objData.systemuserid || ''
                }
                this.$router.push({
                    path:'/member/v2/schedule/index',
                    query: data
                })
            },
            patientia(value, state) {
                // 切换默认值
                if (state) return;
                getSetPact({
                    member_id: this.user_id,
                    contact_id: value
                }).then(
                    (res) => {
                        this.paramse.page = 0;
                        this.listData = [];
                        this.getDataList();
                    }
                );
            },
            article(item, val) {
                // 点击切换项目
                // console.log(val);debugger
                getSetPact({
                    member_id: this.user_id,
                    contact_id: val
                }).then((res) => {
                    /*this.$router.push({
                        path:'/member/v2/index/index'
                    });*/
                    this.$router.go(-1)
                });
                this.listData.forEach(it => {
                    it.is_default = 0
                })
                item.is_default = 1
            },
            getDataList() {
                // 列表接口数据
                let that = this;
                this.$store.commit("loadSkeleton", {
                    bool: true,
                    type: "team"
                }); // 页面loading开启
                Promise.all([
                    that.$userHouse.dispatch("getProecj", that.paramse),
                ]).then((res) => {
                    that.$store.commit("loadSkeleton", {
                        bool: false,
                        type: "team",
                    }); // 页面loading关闭
                    console.log(res, 'getProecj')
                    const {
                        lists,
                        totali
                    } = that.$userHouse.state.userProList;
                    that.total = totali;
                    that.bLoadList = true;
                    that.listData = [...lists, ...that.listData];
                });
            },
            //下拉
            downRefreshTwo(loaded) {
                loaded("done");
                this.paramse.page = 0;
                this.listData = [];
                this.getDataList();
            },
            //上拉
            upRefreshTwo(loaded) {
                loaded("done");
                // 获取数据的总页数
                let pageSize = common.pageCount(this.total, this.paramse.limit);
                if (this.paramse.page >= pageSize) return this.$toast("到底了~");
                this.paramse.page++;
                this.getDataList();
            },

            // monitorBut(){
            //     getCreatelog({

            //     }).then(res =>{

            //     })
            // }
        },
        mounted() {},
    };
</script>
<style lang='scss' scoped>
    .infoReadis {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        background: rgba(0, 0, 0, 0.658);

        div {
            width: 70%;
            height: 200px;
            background: #fff;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .content {
        padding: 28px 24px 28px 24px;
        box-sizing: border-box;
        background: #F9F9F9;

        -webkit-animation: fadeleftIn 0.4s;
        animation: fadeleftIn 0.4s;

        .project-all {
            position: relative;
            margin-top: 76px;

            .project-box {
                width: 654px;
                margin: 0 auto;
                /* background: #FFF; */
                border-radius: 24px 24px 0 0;
                padding: 58px 32px 48px 40px;

                .project-top {
                    display: flex;
                    justify-content: space-between;

                    .title {
                        width: 420px;
                        font-size: 32px;
                        color: #3D3C4F;
                        line-height: 48px;
                        font-weight: 600;
                        display: -webkit-box;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2; //当属性值为3，表示超出3行隐藏
                    }

                    .const {
                        width: 98px;
                        height: 40px;
                        background: #0D53FC;
                        border-radius: 21px;
                        text-align: center;
                        line-height: 42px;
                        margin-top: 16px;
                        color: #FFF;
                    }
                }

                .lable {
                    margin-top: 32px;
                    /* padding: 12px 0 32px 0; */
                    display: flex;

                    .square {
                        font-size: 24px;
                        color: #999999;
                        padding-right: 32px;
                        border-right: 2px solid #DDDDDD;
                    }

                    .room {
                        padding: 0 32px;
                        font-size: 24px;
                        color: #999999;
                        border-right: 2px solid #DDDDDD;
                    }

                    .type {
                        padding: 0 32px;
                        font-size: 24px;
                        color: #999999;
                    }
                }

                .line-box {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    margin-top: 64px;
                    padding: 0 32px;

                    .short-line {
                        position: absolute;
                        z-index: 8;
                        left: 0;
                        top: 8px;
                        /* width: 25px; */
                        height: 6px;
                        background: #679681;
                        border-radius: 28px;
                        /* background: #E5E9E7; */
                    }

                    .long-line {
                        position: absolute;
                        z-index: 4;
                        right: 0;
                        top: 10px;
                        /* width: 280px; */
                        height: 2px;
                        border-radius: 28px;
                        background: #E5E9E7;
                    }

                    .garden-box-wit {
                        position: relative;
                        z-index: 10;
                        border: #EFF1F0 4px solid;
                        border-radius: 50%;
                    }

                    .garden-box {
                        position: relative;
                        width: 16px;
                        height: 16px;
                        background: #355D4B;
                        /* background: rgba(229, 233, 231, 0.11); */
                        border: 6px solid #679681;
                        border-radius: 50%;
                        z-index: 10;
                    }

                    .garden-box-item {
                        position: relative;
                        z-index: 10;
                        width: 16px;
                        height: 16px;
                        background: #FFFFFF;
                        /* background: rgba(229, 233, 231, 0.11); */
                        border: 6px solid #E5E9E7;
                        border-radius: 50%;
                    }
                }

                .process {
                    margin-top: 24px;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 24px;

                    .process-title {
                        font-size: 20px;
                        color: #355D4B;
                        line-height: 24px;
                    }
                }

            }

            .project-bottom {
                width: 654px;
                height: 72px;
                background: rgba(53, 93, 75, 0.05);
                border-radius: 0px 0px 24px 24px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding: 0 32px;

                .bottom-title {
                    font-size: 20px;
                    font-weight: 600;
                    color: #355D4B;
                    line-height: 32px;
                    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                }

                .bottom-img {
                    img {
                        width: 32px;
                        height: 32px;
                    }
                }


            }

            .choice-box {
                position: absolute;
                top: -28px;
                left: 25px;

                img {
                    width: 200px;
                    height: 58px;
                }
            }
        }
        .home_icon{
            position: fixed;
            z-index: 10;
            right: 4px;
            img{
                width: 112px;
                height: 112px;
            }
        }







        .public {
            margin-bottom: 24px;
            border-radius: 12px;
            background: $divBg;
            overflow: hidden;

            .card {
                padding-top: 18px;
                position: relative;
                background: $greenGradient;
                display: flex;

                .img {
                    margin: 0 4px;
                    width: 132px;
                    height: 132px;
                }

                .working {
                    background: url("~@/assets/images/user/house/working_icon.png") no-repeat center/100% 100%;
                }

                .unfinished {
                    background: url("~@/assets/images/user/house/unfinished.png") no-repeat center/100% 100%;
                }

                .uncourse {
                    background: url("~@/assets/images/user/house/uncourse.png") no-repeat center/100% 100%;
                }

                .topping {
                    padding-left: 28px;
                }

                .top {
                    flex: 1;
                    padding-top: 16px;

                    .text {
                        .text-top {
                            font-size: 36px;
                            font-weight: 500;
                            color: #ffffff;
                        }

                        .text-bottom {
                            margin-top: 12px;
                            display: flex;
                            align-items: center;

                            .left {
                                font-size: $baseSize;
                                font-weight: 400;
                                color: rgba(255, 255, 255, 0.8);
                                padding-right: 16px;
                            }

                            .right {
                                font-size: $smallSize;
                                font-weight: 400;
                                color: #ffe56e;
                            }
                        }
                    }

                    .lable {
                        padding: 12px 0 32px 0;

                        div {
                            margin-right: 64px;
                            // padding: 10px 32px;
                            display: inline-block;
                            // border-radius: 46px;
                            // border: 2px solid rgba(255, 255, 255, 0.29);

                            font-size: $baseSize;
                            font-weight: 400;
                            color: rgba(255, 255, 255, 0.8);

                        }
                    }
                }

                .layer {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 160px;
                    height: 44px;
                    text-align: center;
                    line-height: 44px;
                    background: url("~@/assets/images/user/house/label_bg.png") no-repeat center/100% 100%;

                    font-size: $smallSize;
                    font-weight: 400;
                    color: #ffffff;
                }
            }

            .progress {
                padding: 28px;
                position: relative;

                display: flex;
                align-items: center;
                justify-content: space-between;

                .line {
                    position: absolute;
                    top: 46px;
                    left: 50%;
                    width: calc(100% - 72px);
                    transform: translateX(-50%);
                    border-top: 2px dashed rgba(200, 225, 206, 1);
                }

                .progress-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    .img {
                        position: relative;
                        z-index: 9;
                        width: 36px;
                        height: 36px;

                        margin-bottom: 14px;
                    }

                    .imgacd {
                        background: url("~@/assets/images/user/house/finish_icon.png") no-repeat center/100% 100%;
                    }

                    .imghide {
                        background: url("~@/assets/images/user/house/finish_icon_n.png") no-repeat center/100% 100%;
                    }

                    .item-font {
                        font-size: $smallSize;
                        font-weight: 400;
                        color: #649559;
                    }
                }
            }

            .line1 {
                margin: 0 24px;
                border-top: 1px dashed rgba(241, 241, 241, 1);
            }

            .choose {
                padding: 0 28px;
                display: flex;
                align-items: center;

                .left {
                    margin: 16px 8px 20px 0;
                    width: 36px;
                    height: 36px;
                }
            }
        }
    }

    // 默认灰字体
    .font-text {
        font-size: $smallSize;
        font-weight: 400;
        color: #a2a2a2;
    }

    // 默认字体
    .font-text1 {
        font-size: $smallSize;
        font-weight: 400;
        color: #444444;
    }

    // 超出一行省略
    .omit {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    // 超出2行省略
    .omit-s {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    @keyframes fadeleftIn {
        0% {
            -webkit-transform: translate3d(100%, 0, 0);
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);

        }

        100% {
            -webkit-transform: none;
            transform: none;
        }
    }

    @-webkit-keyframes fadeleftIn {
        0% {
            -webkit-transform: translate3d(100%, 0, 0);
        }

        100% {
            -webkit-transform: none;
        }
    }
</style>
